import SharedTextFieldInput from '../shared/TextFieldInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
} from 'reducers/autoPersonalFormReducer';

interface AutoTextFieldInputProps {
  label: string;
  value: string;
  onChange: (event: any) => void;
  section: number;
  [x: string]: any;
}

const AutoTextFieldInput = (props: AutoTextFieldInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
  };

  return (
    <SharedTextFieldInput
      {...props}
      formStateKey="autoPersonalForm"
      formActions={formActions}
    />
  );
};

export default AutoTextFieldInput;
